const ApprovedGreenIcon = ({
  className,
  style,
  onClick,
}: {
  className?: string;
  style?: any;
  onClick?: any;
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_3163_12267)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99984 2.00033C4.68613 2.00033 1.99984 4.68662 1.99984 8.00033C1.99984 11.314 4.68613 14.0003 7.99984 14.0003C11.3135 14.0003 13.9998 11.314 13.9998 8.00033C13.9998 4.68662 11.3135 2.00033 7.99984 2.00033ZM0.666504 8.00033C0.666504 3.95024 3.94975 0.666992 7.99984 0.666992C12.0499 0.666992 15.3332 3.95024 15.3332 8.00033C15.3332 12.0504 12.0499 15.3337 7.99984 15.3337C3.94975 15.3337 0.666504 12.0504 0.666504 8.00033Z"
          fill="#85C553"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4716 6.19526C10.7319 6.45561 10.7319 6.87772 10.4716 7.13807L7.8049 9.80474C7.54455 10.0651 7.12244 10.0651 6.86209 9.80474L5.52876 8.4714C5.26841 8.21106 5.26841 7.78895 5.52876 7.5286C5.78911 7.26825 6.21122 7.26825 6.47157 7.5286L7.3335 8.39052L9.52876 6.19526C9.78911 5.93491 10.2112 5.93491 10.4716 6.19526Z"
          fill="#85C553"
        />
      </g>
      <defs>
        <clipPath id="clip0_3163_12267">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ApprovedGreenIcon;
